"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function seirekiToDate(year, month, date, hour, minute, second) {
    if (month === void 0) { month = 1; }
    if (date === void 0) { date = 1; }
    if (hour === void 0) { hour = 0; }
    if (minute === void 0) { minute = 0; }
    if (second === void 0) { second = 0; }
    if (!year) {
        throw new Error('年は1以上を指定してください。');
    }
    return new Date(year, month - 1, date, hour, minute, second);
}
exports.default = seirekiToDate;
